(ns hai.ui.components.collection.form
  (:require
   [clojure.string :as str]
   [hai.ui.components.form.input :as input]
   [hai.ui.components.form.select.single-select :as single-select]
   [hai.ui.components :as c]
   [hai.ui.rf-sugar :refer [>e]]
   [hai.ui.icons :as icons]
   [lambdaisland.ornament :as o]))

;; `table-input-style`

(defn table-input
  [props]
  [c/TextFieldRoot (-> props
                       (assoc :class "table-cell-input")
                       (update :style merge {:width "100%"}))])

(def table-input-style
  {:input.render/input table-input})

;; `input`

(o/defstyled input* :div
  :flex :items-center
  :w-100% :h-100%
  ([field]
   [input/field (assoc field :render {:style table-input-style})]))

(defn input
  [field]
  [c/TableCell
   {:class ["table-input"]}
   [input* field]])

;; `link-input`

(o/defstyled link-input*-input :div
  :flex :items-center
  :w-100%
  ([field]
   [input/field (assoc field :render {:style table-input-style})]))

(o/defstyled link-input* :div
  :flex :flex-row :items-center
  :w-100% :h-100%
  :gap-2
  [icons/outlined-edit {:fill c/--accent-a11}]
  ([{:keys [route]
     :collection/keys [entity]
     :as field}]
   [:<>
    [c/link-button
     {:on-click (fn [_] (>e [:routing/navigate route]))}
     [icons/outlined-edit]]
    [link-input*-input field]]))

(defn link-input
  [route]
  (fn [{:collection/keys [entity] :as field}]
    [c/TableCell
     {:class ["table-input"]}
     [link-input* (assoc field :route [route entity])]]))

(o/defstyled href-input* :div
  :p-2
  ([{:keys [text href]}]
   [c/Link {:href href :target "_blank"} text]))

(defn href-input
  [{:keys [href]
    :as opts}]
  [c/TableCell
   [href-input* (assoc opts :href (if (str/starts-with? href "http")
                                    href
                                    (str "http://" href)))]])

(defn single-select
  []
  (fn [field]
    [c/TableCell
     {:class ["table-input"]}
     [single-select/field field]]))

(defn toggle
  [{:form.field/keys [set-value! current-value]}]
  [c/TableCell
   {:class ["table-input"]}
   [c/Switch {:checked (boolean current-value)
              :on-checked-change set-value!}]])
